export default "__VITE_ASSET__DdMEb735__"